import { ReactNode, useEffect, useState } from "react";
import { Themes, useGlobalContext } from "../../context/GlobalContext";


export default function ThemeProvider({children} : {children: ReactNode[]})
{
    
  let [theme, setTheme] = useState<Themes>('dark');

  useEffect(()=>{

    let cached = localStorage.getItem('theme');
   
    if(cached)
      setTheme(cached as Themes);
    context.Context?.AfterThemeChangeEvent.forEach(s => s());

    let color = cached == "dark" ? "#161616ff" : "#ffffff";
    let themeMeta = document.querySelector("meta[name='theme-color']");
    themeMeta?.setAttribute("content", color);


  }, [])

  let context = useGlobalContext();

  context.Context!.GetTheme = () => theme;

  context.Context!.ToogleTheme = () => {
    let themes: Themes[] = ['dark', 'light'];
    
    let next = themes.indexOf(theme) == themes.length - 1 ? themes[0] : themes[themes.indexOf(theme) + 1]
    setTheme(next);     
    localStorage.setItem('theme', next);

    let color = next == "dark" ? "#161616ff" : "#ffffff";
    let themeMeta = document.querySelector("meta[name='theme-color']");
    themeMeta?.setAttribute("content", color);

    context.Context?.AfterThemeChangeEvent.forEach(s => s());
  };

    return (
        <div className="ThemeProviderComponent" data-theme={theme}>
            {children}
        </div>
    )
}